import ClearIcon from "@mui/icons-material/Clear"
import SearchIcon from "@mui/icons-material/Search"
import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  Input,
  FilledInput,
  styled,
} from "@mui/material"
import React, { useRef } from "react"

const styleInputComponent = (component: typeof Input) =>
  styled(component)(({ theme }) => ({
    "&.MuiInput-underline::before": {
      borderColor: "#767676",
      borderWidth: 1.5,
    },
    "& > .MuiOutlinedInput-notchedOutline": {
      borderColor: "#767676",
      borderWidth: 1.5,
    },
    "& > .MuiInputBase-input": {
      padding: theme.spacing(1.2),
      "&::placeholder": {
        opacity: 1,
        color: "#767676",
        fontStyle: "italic",
      },
    },
    "& > .MuiInputAdornment-root": {
      "& > .MuiButtonBase-root": {
        padding: 4,
        color: "#000000",
        "&.Mui-disabled": {
          color: "rgba(0, 0, 0, 0.35)",
        },
      },
    },
  }))

export const VARIANT_COMPONENT = {
  standard: styleInputComponent(Input),
  filled: styleInputComponent(FilledInput),
  outlined: styleInputComponent(OutlinedInput),
}

export interface SearchBarProps {
  disabled?: boolean

  iconType?: "search" | "clear"

  onSearch?: () => void
  onClear?: () => void

  onEscape?: () => void
  onEnter?: () => void

  onChange: (newValue: string) => void
  value: string

  placeholder?: string

  variant?: "outlined" | "filled" | "standard"

  className?: string
}

const SearchBar = (props: SearchBarProps) => {
  const {
    placeholder = "Type here...",
    disabled,

    value,
    onChange,

    onClear,
    onSearch,
    variant = "standard",
    className,
    iconType = "search",

    onEscape,
    onEnter,
  } = props
  const outlinedInputRef = useRef(null)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.currentTarget.value)

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && onEnter) return onEnter()
    if (e.key === "Escape" && onEscape) return onEscape()
  }

  const InputComponent = VARIANT_COMPONENT[variant]

  return (
    <InputComponent
      className={className}
      disabled={disabled}
      inputRef={outlinedInputRef}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      type="text"
      onKeyUp={handleKeyUp}
      endAdornment={
        <InputAdornment position="end">
          {iconType === "clear" && (
            <IconButton
              disabled={disabled}
              aria-label="Clear search"
              onClick={onClear}
              size="large">
              <ClearIcon color="inherit" />
            </IconButton>
          )}
          {iconType === "search" && (
            <IconButton disabled={disabled} aria-label="Search" onClick={onSearch} size="large">
              <SearchIcon color="inherit" />
            </IconButton>
          )}
        </InputAdornment>
      }
    />
  )
}

export default SearchBar
